/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {ApolloTestingBackend as ɵc} from './backend';
export {APOLLO_TESTING_CLIENTS as ɵa,ApolloTestingModuleCore as ɵb} from './module';